export default "__VITE_ASSET__68561d0d__"